<template>
  <div class="container-fluid overflow-auto d-flex">
    <div class="w-100 mb-4">
      <div class="row m-0 p-0">
        <div class="col-md-10">
          <h3><i class="fa fa-user-circle"></i> Métricas de Atendimentos</h3>
        </div>
        <div class="col-12 col-md-2 text-md-right mt-3 mt-md-0">
            <defaultbutton
              class="defaultbutton"
              :onClick="() => onShowSearch()"
              btnVariant="btn-third"
              icon="fas fa-search"
              text="Pesquisar"
            />
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12 mb-2">
          <div class="btn-group btn-group-sm" role="group" aria-label="Filtro de métricas">
            <button
              type="button"
              class="btn"
              :class="metricasView === 'geral' ? 'btn-custom-primary' : 'btn-custom-outline'"
              @click="setMetricasView('geral')"
            >
              Geral
            </button>
            <button
              type="button"
              class="btn"
              :class="metricasView === 'organico' ? 'btn-custom-primary' : 'btn-custom-outline'"
              @click="setMetricasView('organico')"
            >
              Orgânico
            </button>
            <button
              type="button"
              class="btn"
              :class="metricasView === 'campanha' ? 'btn-custom-primary' : 'btn-custom-outline'"
              @click="setMetricasView('campanha')"
            >
              Campanha
            </button>
          </div>
        </div>
        <div class="col-md-6 chart-container">
          <DonutChart
            :percentages="percentages"
            :colors="donutColors"
            :label="donutLabel"
            :sector-names="donutSectorNames"
          />
          <p class="mt-2">
            Totais brutos — Orgânicas:
            <strong>{{ totalOrganicas }}</strong>
            &nbsp;|&nbsp; Campanha:
            <strong>{{ totalCampanha }}</strong>
            &nbsp;|&nbsp; Geral:
            <strong>{{ totalGeral }}</strong>
          </p>
        </div>
        <div class="col-md-6 chart-container">
          <div v-for="(card, index) in cards" :key="index" class="card-body">
            <h5 class="card-title">{{ card.title }}</h5>
            <p class="card-text">{{ card.text }}</p>
            <div v-if="index === 2" class="rating">
              <template v-if="card.rating !== null">
                <span v-for="n in 10" :key="n" class="star" :class="{ 'filled': n <= card.rating && card.rating >= 5, 'failed': n <= card.rating && card.rating < 5 }">
                  <i class="fa fa-star"></i>
                </span>
                <p class="rating-text">Nota: {{ card.rating }} / 10</p>
              </template>
              <template v-else>
                <p class="no-data">Sem dados disponíveis</p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import SidebarSearch from '@/views/private/atendimento/indice_atendimento/search/SidebarIndiceAtendimento.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import DonutChart from '@/views/private/atendimento/indice_atendimento/components/DonutChart'
/* eslint-disable */

export default {
  name: 'Indice',
  components: {
    defaultbutton,
    SidebarSearch,
    DonutChart
  },
  data () {
    const today = new Date()
    const startDate = new Date()
    startDate.setDate(today.getDate() - 15)
    startDate.setHours(0, 0, 0, 0)
    const endDate = new Date()
    endDate.setHours(23, 59, 59, 999)

    return {
      mobile: false,
      closeFilter: false,
      showFilter: true,
      buttonPosition: {
        top: 7,
        left: 80
      },
      cards: [
        {
          title: 'Tempo Médio de Espera',
          text: 'Carregando...',
          rating: 0
        },
        {
          title: 'Tempo Médio de Atendimento',
          text: 'Carregando...',
          rating: 0
        },
        {
          title: 'Nota Média',
          text: 'Carregando...',
          rating: 0
        }
      ],
      total: 0,
      totalGeral: 0,
      percentages: [],
      totalOrganicas: 0,
      totalCampanha: 0,
      metricasView: 'geral',
      donutColors: ['#FF5733', '#1BACA0', '#FFC300', '#3498DB', '#9B59B6'],
      donutSectorNames: [
        'Em andamento',
        'Finalizados',
        'Chat de campanha finalizada',
        'Campanha enviada não respondida',
        'Campanha respondida em andamento'
      ],
      donutLabel: 'Total de Atendimentos (geral): 0',
      metricasResumo: {
        finalizados: 0,
        campanhaFinalizados: 0,
        andamento: 0,
        campanhaEnviada: 0,
        campanhaRespondida: 0
      },
      filters: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Finalizado'
      },
      filtersAndamento: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Aberto'
      }
    }
  },
  created () {
    this.convertWindow()
  },
  mounted () {
    this.loadMetricasResumo()
    this.onLoadAll()
  },
  computed: {
    isMobile () {
      return window.innerWidth < 768
    }
  },
  methods: {
    setMetricasView (view) {
      this.metricasView = view
      this.applyMetricasView()
      this.onLoadAll()
    },
    applyMetricasView () {
      const view = this.metricasView

      const totalGeral =
        (this.metricasResumo.finalizados || 0) +
        (this.metricasResumo.campanhaFinalizados || 0) +
        (this.metricasResumo.andamento || 0) +
        (this.metricasResumo.campanhaEnviada || 0) +
        (this.metricasResumo.campanhaRespondida || 0)

      this.totalGeral = totalGeral

      const totalOrganicas =
        (this.metricasResumo.finalizados || 0) + (this.metricasResumo.andamento || 0)
      const totalCampanha =
        (this.metricasResumo.campanhaFinalizados || 0) +
        (this.metricasResumo.campanhaEnviada || 0) +
        (this.metricasResumo.campanhaRespondida || 0)

      this.totalOrganicas = totalOrganicas
      this.totalCampanha = totalCampanha

      let counts = []
      let sectorNames = []
      let colors = []
      let total = 0
      let label = ''

      if (view === 'organico') {
        counts = [this.metricasResumo.andamento || 0, this.metricasResumo.finalizados || 0]
        sectorNames = ['Em andamento', 'Finalizados']
        colors = ['#FF5733', '#1BACA0']
        total = totalOrganicas
        label = 'Total de Atendimentos (orgânico): ' + total
      } else if (view === 'campanha') {
        counts = [
          this.metricasResumo.campanhaEnviada || 0,
          this.metricasResumo.campanhaRespondida || 0,
          this.metricasResumo.campanhaFinalizados || 0
        ]
        sectorNames = [
          'Campanha enviada não respondida',
          'Campanha respondida em andamento',
          'Chat de campanha finalizada'
        ]
        colors = ['#3498DB', '#9B59B6', '#FFC300']
        total = totalCampanha
        label = 'Total de Atendimentos (campanha): ' + total
      } else {
        // geral
        counts = [
          this.metricasResumo.andamento || 0,
          this.metricasResumo.finalizados || 0,
          this.metricasResumo.campanhaFinalizados || 0,
          this.metricasResumo.campanhaEnviada || 0,
          this.metricasResumo.campanhaRespondida || 0
        ]
        sectorNames = [
          'Em andamento',
          'Finalizados',
          'Chat de campanha finalizada',
          'Campanha enviada não respondida',
          'Campanha respondida em andamento'
        ]
        colors = ['#FF5733', '#1BACA0', '#FFC300', '#3498DB', '#9B59B6']
        total = totalGeral
        label = 'Total de Atendimentos (geral): ' + total
      }

      this.total = total
      this.donutSectorNames = sectorNames
      this.donutColors = colors
      this.donutLabel = label

      if (total > 0) {
        this.percentages = counts.map((c) => Number(((c / total) * 100).toFixed(2)))
      } else {
        this.percentages = counts.map(() => 0)
      }
    },
    handleFilter () {
      this.showFilter = !this.showFilter
    },
    convertWindow () {
      if (this.isMobile) {
        this.buttonPosition = {
          top: 9,
          left: 8
        }
        this.showFilter = false
        this.mobile = true
      } else {
        this.mobile = false
      }
    },
    onApplyFilters (newFilters) {
      this.filters = newFilters
      this.onLoadAll()
    },
    onClearFilters () {
      this.filters = {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Finalizado'
      },
      this.filtersAndamento = {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Aberto'
      }
      this.$nextTick(() => {
        this.loadMetricasResumo()
        this.onLoadAll()
      })
    },
    onLoadAll () {
      const baseFilters = {
        ...this.filters,
        status: 'Finalizado'
      }

      if (this.metricasView === 'campanha') {
        baseFilters.botId = ['campanha']
        baseFilters.botIdExclude = null
      } else if (this.metricasView === 'organico') {
        baseFilters.botId = null
        baseFilters.botIdExclude = ['campanha']
      } else {
        baseFilters.botId = null
        baseFilters.botIdExclude = null
      }

      console.log('Iniciando requisição média de atendimentos...', baseFilters)
      const startTime = Date.now()

      return ReportAtendimentoRepository.MedioGetAll(baseFilters)
        .then((response) => {
          const duration = Date.now() - startTime
          console.log(`Resposta recebida em ${duration}ms:`, response.data)
          console.log('Quantidade de atendimentos encontrados:', response.data.quantidadeAtendimentos)
          
          if (response.data.quantidadeAtendimentos === 0) {
            console.warn(' Nenhum atendimento encontrado com os filtros aplicados!')
            console.warn('Verifique se existem atendimentos FINALIZADOS no período selecionado')
          }

          const dataFinalizado = response.data || {}

          this.cards = [
            {
              title: 'Tempo Médio de Espera',
              text: dataFinalizado.mediaTempoEspera ? this.formatTime(dataFinalizado.mediaTempoEspera) : 'Sem dados disponíveis'
            },
            {
              title: 'Tempo Médio de Atendimento',
              text: dataFinalizado.mediaTempoAtendimento ? this.formatTime(dataFinalizado.mediaTempoAtendimento) : 'Sem dados disponíveis'
            },
            {
              title: 'Nota Média',
              rating: dataFinalizado.mediaNotaAtendimento || 0
            }
          ]
        })
        .catch((error) => {
          const duration = Date.now() - startTime
          console.error(`Erro após ${duration}ms:`, error)
          console.error('Detalhes do erro:', {
            status: error && error.status,
            statusText: error && error.statusText,
            data: error && error.data,
            message: error && error.message
          })
          
          // Mantém os cards com mensagem de erro
          this.cards = [
            {
              title: 'Tempo Médio de Espera',
              text: 'Erro ao carregar dados'
            },
            {
              title: 'Tempo Médio de Atendimento',
              text: 'Erro ao carregar dados'
            },
            {
              title: 'Nota Média',
              rating: null
            }
          ]
        })
    },
    async loadMetricasResumo () {
      return AtendimentoRepository.GetMetricasResumo(this.filters)
        .then(response => {
          const { status, data } = response

          if (status === 200 && data) {
            const {
              finalizados,
              campanhaFinalizados,
              andamento,
              campanhaEnviada,
              campanhaRespondida
            } = data

            this.metricasResumo = {
              finalizados: finalizados || 0,
              campanhaFinalizados: campanhaFinalizados || 0,
              andamento: andamento || 0,
              campanhaEnviada: campanhaEnviada || 0,
              campanhaRespondida: campanhaRespondida || 0
            }

            this.applyMetricasView()
          }
        })
    },
    formatTime (milliseconds) {
      const hours = Math.floor(milliseconds / 3600000)
      const minutes = Math.floor((milliseconds % 3600000) / 60000)
      const seconds = Math.floor((milliseconds % 60000) / 1000)

      let formattedTime = ''

      if (hours > 0) {
        formattedTime += `${this.pad(hours)} Horas `
      }
      if (minutes > 0 || hours > 0) {
        formattedTime += `${this.pad(minutes)} Minutos `
      }
      if (seconds > 0 || minutes > 0 || hours > 0) {
        formattedTime += `${this.pad(seconds)} Segundos `
      }

      return formattedTime.trim()
    },
    pad (number) {
      return number < 10 ? '0' + number : number
    },
    onSearch (filters, filtersAndamento) {
      this.filters = filters
      this.filtersAndamento = filtersAndamento
      this.$nextTick(() => {
        this.loadMetricasResumo()
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-container {
  max-width: 400px;
  min-width: 400px;
  background-color: #f8f9fa;
  padding: 20px
}

.rating {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.btn-custom-outline{
  background-color: #04a791;
  border-color: #04a791;
  color: white;
}

.btn-custom-primary{
  background-color: transparent;
  border: 1px solid #6c757d;
  color: #6c757d;
}

.star {
  font-size: 1.5rem;
  color: #e4e5e9;
  transition: color 0.2s;
}

.star.filled {
  color: #0BACA0;
}

.star.failed {
  color: #f03535;
}

.rating-text {
  margin-left: 10px;
  font-size: 1rem;
}

.card-text {
  font-size: 1.25rem;
}

.no-data {
  font-size: 1rem;
  color: #6c757d;
}

@media (max-width: 576px) {
  .container-fluid {
    padding: 10px;
    align-items: stretch;
  }

  .chart-container {
    max-width: 100% !important;
    min-width: auto;
    padding: 10px;
    margin-bottom: 20px;
  }

  .card-body {
    padding: 10px;
    text-align: center;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .card-text {
    font-size: 1rem;
  }

  .rating-text {
    font-size: 0.9rem;
    margin-left: 0;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .defaultbutton {
    width: 100%;
    justify-content: center;
  }

  .row > .col-12.col-md-3.ml-auto {
    margin-left: 0 !important;
  }

  h3 {
    font-size: 1.40rem;
    text-align: center;
  }

  .fa-user-circle {
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/indice_atendimento/indice.vue